var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [_c("v-tab", [_vm._v("Solicitud Anulación Venta")])],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "asignacionNoSeriado sav_crm" },
        [
          _c(
            "v-card",
            [
              _c(
                "div",
                {
                  staticClass: "layout row wrap",
                  staticStyle: {
                    "padding-right": "0px",
                    "padding-left": "10px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "layout row wrap flex xs12 sm8 md8",
                      staticStyle: {
                        "padding-right": "0px",
                        "padding-left": "10px"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex xs6 sm3 md3" },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Clientes",
                              "item-text": "nombre",
                              "item-value": "rut",
                              items: _vm.filtro_cliente,
                              clearable: "",
                              "prepend-icon": "account_circle"
                            },
                            model: {
                              value: _vm.model_filtro_cliente,
                              callback: function($$v) {
                                _vm.model_filtro_cliente = $$v
                              },
                              expression: "model_filtro_cliente"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex xs6 sm3 md3" },
                        [
                          _c("DatePicker", {
                            attrs: {
                              locale: "es-cl",
                              color: "primary",
                              label: "Fecha Inicio"
                            },
                            model: {
                              value: _vm.model_filtro_inicio,
                              callback: function($$v) {
                                _vm.model_filtro_inicio = $$v
                              },
                              expression: "model_filtro_inicio"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex xs6 sm3 md3" },
                        [
                          _c("DatePicker", {
                            attrs: {
                              locale: "es-cl",
                              color: "primary",
                              label: "Fecha Fin"
                            },
                            model: {
                              value: _vm.model_filtro_fin,
                              callback: function($$v) {
                                _vm.model_filtro_fin = $$v
                              },
                              expression: "model_filtro_fin"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex xs6 sm3 md3" },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Nota de venta",
                              "item-text": "nombre_nota_venta",
                              "item-value": "nombre_nota_venta",
                              items: _vm.filtro_nota_de_venta,
                              clearable: "",
                              "prepend-icon": "description"
                            },
                            model: {
                              value: _vm.model_filtro_nota_de_venta,
                              callback: function($$v) {
                                _vm.model_filtro_nota_de_venta = $$v
                              },
                              expression: "model_filtro_nota_de_venta"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex xs6 sm3 md3" },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Estado CRM",
                              "item-text": "estado_crm",
                              "item-value": "estado_crm",
                              items: _vm.filtro_estados,
                              clearable: "",
                              "prepend-icon": "description"
                            },
                            model: {
                              value: _vm.model_filtro_estados,
                              callback: function($$v) {
                                _vm.model_filtro_estados = $$v
                              },
                              expression: "model_filtro_estados"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex xs6 sm3 md3" },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Razón Estado CRM",
                              "item-text": "razon_estado_crm",
                              "item-value": "razon_estado_crm",
                              items: _vm.filtro_razon_estado,
                              clearable: "",
                              "prepend-icon": "description"
                            },
                            model: {
                              value: _vm.model_filtro_razon_estado,
                              callback: function($$v) {
                                _vm.model_filtro_razon_estado = $$v
                              },
                              expression: "model_filtro_razon_estado"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex xs6 sm3 md3" },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Devuelto a Finanzas",
                              "item-text": "devuelto",
                              "item-value": "devuelto",
                              items: _vm.filtro_devuelto,
                              clearable: "",
                              "prepend-icon": "description"
                            },
                            model: {
                              value: _vm.model_filtro_devuelto,
                              callback: function($$v) {
                                _vm.model_filtro_devuelto = $$v
                              },
                              expression: "model_filtro_devuelto"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: " row wrap xs12 sm4 md4",
                      staticStyle: {
                        "padding-right": "0px",
                        "padding-left": "10px"
                      }
                    },
                    [
                      _c("div", { staticClass: "flex xs6 sm3 md3" }, [
                        _c(
                          "div",
                          { staticClass: "text-sm-center botones-filtros" },
                          [
                            _c("div", { staticClass: "flex xs6 sm3 md1" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "text-sm-center botones-filtros"
                                },
                                [
                                  _c(
                                    "v-btn",
                                    { on: { click: _vm.applyfilters } },
                                    [
                                      _c("v-icon", [_vm._v("search")]),
                                      _vm._v("Filtrar")
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "flex xs6 sm3 md3" }, [
                        _c(
                          "div",
                          { staticClass: "text-sm-center botones-filtros" },
                          [
                            _c("div", { staticClass: "flex xs6 sm3 md1" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "text-sm-center botones-filtros"
                                },
                                [
                                  _c(
                                    "v-btn",
                                    { on: { click: _vm.cleanfilters } },
                                    [
                                      _c("v-icon", [_vm._v("clear")]),
                                      _vm._v("Limpiar")
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "layout row wrap",
                  staticStyle: {
                    "padding-right": "0px",
                    "padding-left": "10px"
                  }
                },
                [
                  _c("div", {
                    staticClass: "flex xs12 sm6 md6",
                    attrs: { align: "lef" }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "flex xs12 sm6 md6",
                      attrs: { align: "right" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", small: "", color: "primary" },
                          on: { click: _vm.btn_exportar }
                        },
                        [
                          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                            _vm._v("cloud_download")
                          ]),
                          _vm._v("  \n            "),
                          _c(
                            "span",
                            {
                              staticClass: "importExportBtnTexto",
                              staticStyle: { "margin-right": "30px" }
                            },
                            [_vm._v("Exportar csv")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "gridcard rounded-card" },
                [
                  _c("MantenedorGridSinCodigo", {
                    attrs: {
                      "grid-options": _vm.gridOptions,
                      "funcionalidad-id": _vm.funcionalidad
                    }
                  })
                ],
                1
              ),
              _vm.ModalDetalleSAV
                ? _c("modalVerDetalleSAV", {
                    attrs: {
                      show: _vm.ModalDetalleSAV,
                      ID_SAV_SELECCIONADA: _vm.SAV_SELECCIONADA,
                      NDV_SELECCIONADA: _vm.NDV_SELECCIONADA
                    },
                    on: {
                      modalverDetalleEmit: function($event) {
                        return _vm.ModalDetalleSAV_callback($event)
                      }
                    }
                  })
                : _vm._e(),
              _vm.showReporteGenerado
                ? _c("div", { staticClass: "wrap-evidencia" }, [
                    _c(
                      "div",
                      { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
                      [
                        _c("div", { staticClass: "modalEnvio-content" }, [
                          _c(
                            "div",
                            [
                              _c("div", { staticClass: "titleEvidencia" }, [
                                _c(
                                  "h2",
                                  { staticClass: "importExportBtnIcon" },
                                  [_vm._v("Reporte Solicitado")]
                                )
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "buttonClose buttonCloseEvidencia",
                                  attrs: { align: "right" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        flat: "",
                                        small: "",
                                        color: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.closeReporte()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { staticClass: "importExportBtnIcon" },
                                        [_vm._v("close")]
                                      ),
                                      _vm._v("  \n                  "),
                                      _c(
                                        "span",
                                        { staticClass: "importExportBtnTexto" },
                                        [_vm._v("Cerrar")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                                _c("div", { staticClass: "text-sm-center" }, [
                                  _c(
                                    "p",
                                    { staticStyle: { "margin-top": "40px" } },
                                    [_vm._v(_vm._s(_vm.texto_reporte))]
                                  )
                                ]),
                                _c("div", { staticClass: "text-sm-center" }, [
                                  _c(
                                    "p",
                                    { staticStyle: { "margin-top": "40px" } },
                                    [
                                      _vm._v(
                                        "\n                    Puede ver sus reportes en el menú\n                    "
                                      ),
                                      _c(
                                        "router-link",
                                        {
                                          staticStyle: {
                                            cursor: "pointer",
                                            "font-size": "13px"
                                          },
                                          attrs: {
                                            "active-class":
                                              "router-link-active",
                                            to: "/conecta-reportes"
                                          }
                                        },
                                        [_vm._v("Informes")]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _c("app-confirmacion", {
                attrs: {
                  show: _vm.mostrarModalCONFIRMAR,
                  titulo: _vm.$t("Confirmación"),
                  mensaje: _vm.Modal_confirmar_TEXTO,
                  textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
                  textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
                },
                on: {
                  modalConfirmationEmit: function($event) {
                    return _vm.confirmCallback($event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }